interface Benefit {
	title: string;
	description: string;
}

interface ServiceBenefitsProps {
	benefits: Benefit[];
}

export function ServiceBenefits({ benefits }: ServiceBenefitsProps) {
	return (
		<section className='mt-4 text-base leading-5 max-md:max-w-full'>
			<strong>After these session you will have:</strong>
			<ul className='list-disc pl-5 mt-2 space-y-2'>
				{benefits.map((benefit, index) => (
					<li key={index}>
						<strong>{benefit.title}:</strong> {benefit.description}
					</li>
				))}
			</ul>
		</section>
	);
}
